import { Typography } from "@mui/material";
import React from "react";

const Links = ({ links }) => {
  const renderLinkItem = (data, isArchived = false) => {
    return (
      <div
        style={{
          display: "flex",
          marginBottom: "6px",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "20px",
          padding: "4px 10px",
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Typography
            variant="subtitle2"
            component="subtitle2"
            onClick={() => window.open(data, "_blank")}
            style={{
              fontFamily: "DM Sans",
              fontWeight: "200",
              textDecoration: "underline",
              color: "#0058B8",
              cursor: "pointer",
              fontSize: "10px",
              marginTop: "4px",
              marginLeft: "3px",
            }}
          >
            {data.slice(0, 36)}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        backgroundColor: "#FCEFD8",
        borderRadius: "4px",
        padding: "10px",
        border: "1px solid #F5CC3B",
        margin: "10px 0px",
        overflowY: "auto",
      }}
    >
      {links?.length > 0 ? (
        links.map((data) => renderLinkItem(data))
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            fontFamily: "DM Sans",
            fontSize: "12px",
          }}
        >
          No Links available
        </div>
      )}
    </div>
  );
};

export default Links;
